import axios from "axios";
import { returnURL, returnJson } from "../ApiSettings/returnURL";
const BaseUrl = "api/Button/List";
const ActiveCallsUrl = "api/Calls/List";
const StoreCallsUrl = "api/Button/Register";
const DriverInfoUrl = "api/Drivers/Info";
const CallInfoUrl = "api/Drivers/GetDriverInCallInfo";
const CancelCallURl = "api/Calls/Cancel";
const CostCallUrl = "api/Calls/Cost";

// Get Active Calls
export async function getActiveCallsApi(url, start, end, token) {
  let url_request = url;
  url_request = returnURL(url_request) + BaseUrl;

  let params = {
    returnReservations: false,
    maxResults: 50,
    startTimeStampOfCalls: start,
    endTimeStampOfCalls: end,
    needAllCalls: false,
    filterOnCheckedStatus: 1,
  };

  return await axios.post(url_request, params, {
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    timeout: 60000,
  });
}

// Store New Call
export async function storeCallApi(url, callRequest, token) {
  let url_request = url;
  url_request = returnURL(url_request) + StoreCallsUrl;

  let params = callRequest;

  return await axios.post(url_request, params, {
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    timeout: 60000,
  });
}

// Store New Appointment
export async function storeAppointmentApi(url, callRequest, token) {
  let url_request = url;
  url_request = returnURL(url_request) + StoreCallsUrl;

  let params = callRequest;

  return await axios.post(url_request, params, {
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    timeout: 60000,
  });
}

// Remake Call
export async function remakeCallApi(url, request_object, token) {
  let url_request = url;
  url_request = returnURL(url_request) + StoreCallsUrl;

  let params = request_object;

  return await axios.post(url_request, params, {
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    timeout: 60000,
  });
}

//Cancel Call
export async function cancelCallApi(url, request_object, token) {
  let url_request = url;
  url_request = returnURL(url_request) + CancelCallURl;

  let params = request_object;

  return await axios.post(url_request, params, {
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    timeout: 60000,
  });
}

// Get Driver Info
export async function getDriverInfoApi(url, id, token) {
  let url_request = url;
  url_request = returnURL(url_request) + DriverInfoUrl;

  url_request = url_request + "/" + id;

  return await axios.get(url_request, {
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    timeout: 60000,
  });
}

// Get Call Info
export async function getCallsInfoApi(url, id, token) {
  let url_request = url;
  url_request = returnURL(url_request) + CallInfoUrl;

  let params = {
    driverIds: ["2697"],
    callId: [id],
  };

  return await axios.post(url_request, params, {
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    timeout: 60000,
  });
}

//Get Distance and Time
export async function getDistanceApi(Api_key, origin, distance) {
  let url =
    "https://maps.googleapis.com/maps/api/distancematrix/json?origins=Washington%2C%20DC&destinations=New%20York%20City%2C%20NY";

  return await axios.get(url, {
    timeout: 60000,
  });
}

// Calculate Cost
export async function costCallApi(url, object, token) {
  let url_request = url;
  url_request = returnURL(url_request) + CostCallUrl;

  let params = object;

  return await axios.post(url_request, params, {
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    timeout: 60000,
  });
}
